/**
 * @author Mr_FabiozZz[mr.fabiozzz@gmail.com]
 * @link(+7 953 364 4646)
 * @author Альберт Евстратов
 */
import { RecursiveSelectItems } from "pages/RolesSetup/RecursiveWrapper";

export const newState: RecursiveSelectItems = [
	{
		id: "dictionaries",
		name: "Справочники",
		someIfsOff: [
			"okved",
			"inapplicability_reason",
			"activity_area",
			"person_status",
			"markers",
			"object_type",
			"threat_consequence",
			"construction_objects",
			"threats",
			"threat_model",
			"significance_criteria",
			"document_patterns",
			"statuses_objects",
			"ownership_type",
			"business_process_pattern",
		],
		someIfsOn: [
			"okved",
			"inapplicability_reason",
			"activity_area",
			"person_status",
			"markers",
			"object_type",
			"threat_consequence",
			"construction_objects",
			"threat_model",
			"threats",
			"significance_criteria",
			"document_patterns",
			"statuses_objects",
			"ownership_type",
			"business_process_pattern",
		],
		fields: [
			{
				id: "okved",
				name: "Коды ОКВЭД",
				someIfsOff: ["dictionary.okved.read", "dictionary.okved.import", "dictionary.okved.edit"],
				someIfsOn: ["dictionary.okved.read", "dictionary.okved.import", "dictionary.okved.edit"],
				fields: [
					{
						id: "dictionary.okved.read",
						name: "Просмотр",
						fields: null,
						someIfsOff: ["dictionary.okved.edit", "dictionary.okved.import"],
						someIfsOn: null,
					},
					{
						id: "dictionary.okved.edit",
						name: "Редактирование/добавление данных",
						fields: null,
						someIfsOff: null,
						someIfsOn: ["dictionary.okved.read"],
					},
					{
						id: "dictionary.okved.import",
						name: "Загрузка файлов",
						fields: null,
						someIfsOff: null,
						someIfsOn: ["dictionary.okved.read"],
					},
				],
			},
			{
				id: "markers",
				name: "Маркеры организации",
				someIfsOff: [
					"dictionary.organization_marker.read",
					"dictionary.organization_marker.edit",
					"dictionary.organization_marker.import",
				],
				someIfsOn: [
					"dictionary.organization_marker.read",
					"dictionary.organization_marker.edit",
					"dictionary.organization_marker.import",
				],
				fields: [
					{
						id: "dictionary.organization_marker.read",
						name: "Просмотр",
						fields: null,
						someIfsOff: ["dictionary.organization_marker.edit", "dictionary.organization_marker.import"],
						someIfsOn: null,
					},
					{
						id: "dictionary.organization_marker.edit",
						name: "Редактирование/добавление данных",
						fields: null,
						someIfsOff: null,
						someIfsOn: ["dictionary.organization_marker.read"],
					},
					{
						id: "dictionary.organization_marker.import",
						name: "Загрузка файлов",
						fields: null,
						someIfsOff: null,
						someIfsOn: ["dictionary.organization_marker.read"],
					},
				],
			},
			{
				id: "threats",
				name: "Угрозы",
				someIfsOff: ["dictionary.threat.read", "dictionary.threat.edit", "dictionary.threat.import"],
				someIfsOn: ["dictionary.threat.read", "dictionary.threat.edit", "dictionary.threat.import"],
				fields: [
					{
						id: "dictionary.threat.read",
						name: "Просмотр",
						fields: null,
						someIfsOff: ["dictionary.threat.edit", "dictionary.threat.import", "threats"],
						someIfsOn: null,
					},
					{
						id: "dictionary.threat.edit",
						name: "Редактирование/добавление данных",
						fields: null,
						someIfsOff: null,
						someIfsOn: ["dictionary.threat.read"],
					},
					{
						id: "dictionary.threat.import",
						name: "Загрузка файлов",
						fields: null,
						someIfsOff: null,
						someIfsOn: ["dictionary.threat.read"],
					},
				],
			},
			{
				id: "statuses_objects",
				name: "Статусы объектов",
				someIfsOff: [
					"dictionary.object_status.read",
					"dictionary.object_status.edit",
					"dictionary.object_status.import",
				],
				someIfsOn: [
					"dictionary.object_status.read",
					"dictionary.object_status.edit",
					"dictionary.object_status.import",
				],
				fields: [
					{
						id: "dictionary.object_status.read",
						name: "Просмотр",
						fields: null,
						someIfsOff: ["dictionary.object_status.edit", "dictionary.object_status.import"],
						someIfsOn: null,
					},
					{
						id: "dictionary.object_status.edit",
						name: "Редактирование/добавление данных",
						fields: null,
						someIfsOff: null,
						someIfsOn: ["dictionary.object_status.read"],
					},
					{
						id: "dictionary.object_status.import",
						name: "Загрузка файлов",
						fields: null,
						someIfsOff: null,
						someIfsOn: ["dictionary.object_status.read"],
					},
				],
			},
			{
				id: "inapplicability_reason",
				name: "Причина неприменимости показателей критериев значимости",
				someIfsOff: [
					"dictionary.inapplicability_reason.read",
					"dictionary.inapplicability_reason.edit",
					"dictionary.inapplicability_reason.import",
				],
				someIfsOn: [
					"dictionary.inapplicability_reason.read",
					"dictionary.inapplicability_reason.edit",
					"dictionary.inapplicability_reason.import",
				],
				fields: [
					{
						id: "dictionary.inapplicability_reason.read",
						name: "Просмотр",
						fields: null,
						someIfsOff: ["dictionary.inapplicability_reason.edit", "dictionary.inapplicability_reason.import"],
						someIfsOn: null,
					},
					{
						id: "dictionary.inapplicability_reason.edit",
						name: "Редактирование/добавление данных",
						fields: null,
						someIfsOff: null,
						someIfsOn: ["dictionary.inapplicability_reason.read"],
					},
					{
						id: "dictionary.inapplicability_reason.import",
						name: "Загрузка файлов",
						fields: null,
						someIfsOff: null,
						someIfsOn: ["dictionary.inapplicability_reason.read"],
					},
				],
			},
			{
				id: "object_type",
				name: "Типы объектов",
				someIfsOff: ["dictionary.object_type.read", "dictionary.object_type.edit", "dictionary.object_type.import"],
				someIfsOn: ["dictionary.object_type.read", "dictionary.object_type.edit", "dictionary.object_type.import"],
				fields: [
					{
						id: "dictionary.object_type.read",
						name: "Просмотр",
						fields: null,
						someIfsOff: ["dictionary.object_type.edit", "dictionary.object_type.import"],
						someIfsOn: null,
					},
					{
						id: "dictionary.object_type.edit",
						name: "Редактирование/добавление данных",
						fields: null,
						someIfsOff: null,
						someIfsOn: ["dictionary.object_type.edit"],
					},
					{
						id: "dictionary.object_type.import",
						name: "Загрузка файлов",
						fields: null,
						someIfsOff: null,
						someIfsOn: ["dictionary.object_type.edit"],
					},
				],
			},
			{
				id: "significance_criteria",
				name: "Показатели критериев значимости",
				someIfsOff: [
					"dictionary.significance_criteria.read",
					"dictionary.significance_criteria.edit",
					"dictionary.significance_criteria.import",
				],
				someIfsOn: [
					"dictionary.significance_criteria.read",
					"dictionary.significance_criteria.edit",
					"dictionary.significance_criteria.import",
				],
				fields: [
					{
						id: "dictionary.significance_criteria.read",
						name: "Просмотр",
						fields: null,
						someIfsOff: ["dictionary.significance_criteria.edit", "dictionary.significance_criteria.import"],
						someIfsOn: null,
					},
					{
						id: "dictionary.significance_criteria.edit",
						name: "Редактирование/добавление данных",
						fields: null,
						someIfsOff: null,
						someIfsOn: ["dictionary.significance_criteria.edit"],
					},
					{
						id: "dictionary.significance_criteria.import",
						name: "Загрузка файлов",
						fields: null,
						someIfsOff: null,
						someIfsOn: ["dictionary.significance_criteria.edit"],
					},
				],
			},
			{
				id: "ownership_type",
				name: "Виды владения",
				someIfsOff: [
					"dictionary.ownership_type.read",
					"dictionary.ownership_type.edit",
					"dictionary.ownership_type.import",
				],
				someIfsOn: [
					"dictionary.ownership_type.read",
					"dictionary.ownership_type.edit",
					"dictionary.ownership_type.import",
				],
				fields: [
					{
						id: "dictionary.ownership_type.read",
						name: "Просмотр",
						fields: null,
						someIfsOff: ["dictionary.ownership_type.edit", "dictionary.ownership_type.import"],
						someIfsOn: null,
					},
					{
						id: "dictionary.ownership_type.edit",
						name: "Редактирование/добавление данных",
						fields: null,
						someIfsOff: null,
						someIfsOn: ["dictionary.ownership_type.edit"],
					},
					{
						id: "dictionary.ownership_type.import",
						name: "Загрузка файлов",
						fields: null,
						someIfsOff: null,
						someIfsOn: ["dictionary.ownership_type.edit"],
					},
				],
			},
			{
				id: "activity_area",
				name: "Сфера деятельности",
				someIfsOff: [
					"dictionary.activity_area.read",
					"dictionary.activity_area.edit",
					"dictionary.activity_area.import",
				],
				someIfsOn: [
					"dictionary.activity_area.read",
					"dictionary.activity_area.edit",
					"dictionary.activity_area.import",
				],
				fields: [
					{
						id: "dictionary.activity_area.read",
						name: "Просмотр",
						fields: null,
						someIfsOff: ["dictionary.activity_area.edit", "dictionary.activity_area.import"],
						someIfsOn: null,
					},
					{
						id: "dictionary.activity_area.edit",
						name: "Редактирование/добавление данных",
						fields: null,
						someIfsOff: null,
						someIfsOn: ["dictionary.activity_area.read"],
					},
					{
						id: "dictionary.activity_area.import",
						name: "Загрузка файлов",
						fields: null,
						someIfsOff: null,
						someIfsOn: ["dictionary.activity_area.read"],
					},
				],
			},
			{
				id: "threat_consequence",
				name: "Последствия реализации угроз",
				someIfsOff: [
					"dictionary.threat_consequence.read",
					"dictionary.threat_consequence.edit",
					"dictionary.threat_consequence.import",
				],
				someIfsOn: [
					"dictionary.threat_consequence.read",
					"dictionary.threat_consequence.edit",
					"dictionary.threat_consequence.import",
				],
				fields: [
					{
						id: "dictionary.threat_consequence.read",
						name: "Просмотр",
						fields: null,
						someIfsOff: ["dictionary.threat_consequence.edit", "dictionary.threat_consequence.import"],
						someIfsOn: null,
					},
					{
						id: "dictionary.threat_consequence.edit",
						name: "Редактирование/добавление данных",
						fields: null,
						someIfsOff: null,
						someIfsOn: ["dictionary.threat_consequence.read"],
					},
					{
						id: "dictionary.threat_consequence.import",
						name: "Загрузка файлов",
						fields: null,
						someIfsOff: null,
						someIfsOn: ["dictionary.threat_consequence.read"],
					},
				],
			},
			{
				id: "person_status",
				name: "Статусы работы сотрудников",
				someIfsOff: [
					"dictionary.person_status.read",
					"dictionary.person_status.edit",
					"dictionary.person_status.import",
				],
				someIfsOn: [
					"dictionary.person_status.read",
					"dictionary.person_status.edit",
					"dictionary.person_status.import",
				],
				fields: [
					{
						id: "dictionary.person_status.read",
						name: "Просмотр",
						fields: null,
						someIfsOff: ["dictionary.person_status.edit", "dictionary.person_status.import"],
						someIfsOn: null,
					},
					{
						id: "dictionary.person_status.edit",
						name: "Редактирование/добавление данных",
						fields: null,
						someIfsOff: null,
						someIfsOn: ["dictionary.person_status.read"],
					},
					{
						id: "dictionary.person_status.import",
						name: "Загрузка файлов",
						fields: null,
						someIfsOff: null,
						someIfsOn: ["dictionary.person_status.read"],
					},
				],
			},
			{
				id: "construction_objects",
				name: "Объекты капитального строительства",
				someIfsOff: [
					"dictionary.construction_objects.read",
					"dictionary.construction_objects.edit",
					"dictionary.construction_objects.import",
				],
				someIfsOn: [
					"dictionary.construction_objects.read",
					"dictionary.construction_objects.edit",
					"dictionary.construction_objects.import",
				],
				fields: [
					{
						id: "dictionary.construction_objects.read",
						name: "Просмотр",
						fields: null,
						someIfsOff: ["dictionary.construction_objects.edit", "dictionary.construction_objects.import"],
						someIfsOn: null,
					},
					{
						id: "dictionary.construction_objects.edit",
						name: "Редактирование/добавление данных",
						fields: null,
						someIfsOff: null,
						someIfsOn: ["dictionary.construction_objects.read"],
					},
					{
						id: "dictionary.construction_objects.import",
						name: "Загрузка файлов",
						fields: null,
						someIfsOff: null,
						someIfsOn: ["dictionary.construction_objects.read"],
					},
				],
			},
			{
				id: "document_patterns",
				name: "Справочник шаблонов документов организации",
				someIfsOff: [
					"dictionary.document_patterns.read",
					"dictionary.document_patterns.edit",
					"dictionary.user_document_patterns.edit",
					// "dictionary.document_patterns.import",
				],
				someIfsOn: [
					"dictionary.document_patterns.read",
					"dictionary.document_patterns.edit",
					"dictionary.user_document_patterns.read",
					"dictionary.user_document_patterns.edit",
					// "dictionary.document_patterns.import",
				],
				fields: [
					{
						id: "dictionary.document_patterns.read",
						name: "Просмотр системных шаблонов",
						fields: null,
						someIfsOff: ["dictionary.document_patterns.edit"],
						someIfsOn: null,
					},
					{
						id: "dictionary.document_patterns.edit",
						name: "Редактирование системных шаблонов",
						fields: null,
						someIfsOff: null,
						someIfsOn: ["dictionary.document_patterns.read"],
					},
					{
						id: "dictionary.user_document_patterns.read",
						name: "Просмотр пользовательских шаблонов",
						fields: null,
						someIfsOff: ["dictionary.user_document_patterns.edit"],
						someIfsOn: null,
					},
					{
						id: "dictionary.user_document_patterns.edit",
						name: "Редактирование пользовательских шаблонов",
						fields: null,
						someIfsOff: null,
						someIfsOn: ["dictionary.user_document_patterns.read"],
					},
				],
			},
			{
				id: "business_process_pattern",
				name: "Шаблоны реестра бизнес-процессов",
				someIfsOff: [
					"dictionary.business_process_pattern.read",
					"dictionary.business_process_pattern.edit",
					"dictionary.business_process_pattern.import",
				],
				someIfsOn: [
					"dictionary.business_process_pattern.read",
					"dictionary.business_process_pattern.edit",
					"dictionary.business_process_pattern.import",
				],
				fields: [
					{
						id: "dictionary.business_process_pattern.read",
						name: "Просмотр",
						fields: null,
						someIfsOff: ["dictionary.business_process_pattern.edit", "dictionary.business_process_pattern.import"],
						someIfsOn: null,
					},
					{
						id: "dictionary.business_process_pattern.edit",
						name: "Редактирование/добавление данных",
						fields: null,
						someIfsOff: null,
						someIfsOn: ["dictionary.business_process_pattern.read"],
					},
					{
						id: "dictionary.business_process_pattern.import",
						name: "Загрузка файлов",
						fields: null,
						someIfsOff: null,
						someIfsOn: ["dictionary.business_process_pattern.read"],
					},
				],
			},
			{
				id: "threat_model",
				name: "Справочник шаблонов моделей угроз",
				someIfsOff: [
					"dictionary.threat_model_template.read",
					"dictionary.threat_model_template.edit",
					"dictionary.threat_model_template.delete",
				],
				someIfsOn: [
					"dictionary.threat_model_template.read",
					"dictionary.threat_model_template.edit",
					"dictionary.threat_model_template.delete",
				],
				fields: [
					{
						id: "dictionary.threat_model_template.read",
						name: "Просмотр",
						fields: null,
						someIfsOff: ["dictionary.threat_model_template.edit", "dictionary.threat_model_template.delete"],
						someIfsOn: null,
					},
					{
						id: "dictionary.threat_model_template.edit",
						name: "Редактирование/добавление данных",
						fields: null,
						someIfsOff: null,
						someIfsOn: ["dictionary.threat_model_template.read"],
					},
					// {
					// 	id: "dictionary.threat_model_template.delete",
					// 	name: "Удаление",
					// 	fields: null,
					// 	someIfsOff: null,
					// 	someIfsOn: ["dictionary.threat_model_template.read"],
					// },
				],
			},
		],
	},
	{
		id: "system",
		name: "Взаимодействие с системой",
		someIfsOff: [
			"system.organization.read",
			"system.organization.create",
			"system.organization.edit",
			"system.organization.delete",
			"system.user_dictionary.read",
			"system.user.read",
			"system.user.create",
			"system.user.edit",
			"system.user.delete",
			"system.user.employee_bind",
			"system.employee_dictionary.read",
			"system.employee.read",
			"system.employee.create",
			"system.employee.edit",
			"system.employee.user_bind",
		],
		someIfsOn: [
			"system.organization.read",
			"system.organization.create",
			"system.organization.edit",
			"system.organization.delete",
			"system.user_dictionary.read",
			"system.user.read",
			"system.user.create",
			"system.user.edit",
			"system.user.delete",
			"system.user.employee_bind",
			"system.employee_dictionary.read",
			"system.employee.read",
			"system.employee.create",
			"system.employee.edit",
			"system.employee.user_bind",
		],
		fields: [
			{
				id: "system.organization.read",
				name: "Просмотр организаций",
				fields: null,
				someIfsOff: [
					"categoryzation",
					"system.organization.edit",
					"system.organization.delete",
					"system.organization.create",
					"step_one",
					"step_two",
					"step_three",
					"step_four",
					"step_five",
					"step_six",
					"step_seven",
					"categorization.commission.read",
					"categorization.commission.edit",
					"categorization.commission.delete",
					"categorization.business_process_registry.read",
					"categorization.business_process_registry.print",
					"categorization.business_process_registry.edit",
					"categorization.approved_business_process_registry.upload",
					"categorization.object_registry.read",
					"categorization.object_registry.print",
					"categorization.object_registry.edit",
					"categorization.approved_object_registry.upload",
					"categorization.object_list.read",
					"categorization.object_list.edit",
					"categorization.object_list.print",
					"categorization.approved_object_list.upload",
					"categorization.threat_model.read",
					"categorization.threat_model.edit",
					"categorization.approved_threat_model.upload",
					"categorization.step_5.read",
					"categorization.category.assign",
					"categorization.location_document.delete",
					"categorization.approved_categorization_document.upload",
					"categorization.categorization_document.read",
					"categorization.step_6.read",
					"categorization.fstek_export_bundle.create",
					"categorization.fstek_export_bundle.read",
					"categorization.step_7.read",
					"categorization.step_7.edit",
					"document.organization_archive.read",
					"document.categorization_archive.read",
					"document.organization.read",
					"document.folder.create",
					"document.upload",
					"document.archival",
					"document.archive.restore",
					"document.version.read",
					"document.categorization.read",
				],
				someIfsOn: null,
			},
			{
				id: "system.organization.create",
				name: "Создание организаций",
				fields: null,
				someIfsOff: null,
				someIfsOn: ["system.organization.read"],
			},
			{
				id: "system.organization.edit",
				name: "Редактирование данных организации",
				fields: null,
				someIfsOff: null,
				someIfsOn: ["system.organization.read"],
			},
			{
				id: "system.organization.delete",
				name: "Удаление организации",
				fields: null,
				someIfsOff: null,
				someIfsOn: ["system.organization.read"],
			},
			{
				id: "system.user_dictionary.read",
				name: "Просмотр справочника пользователей",
				fields: null,
				someIfsOff: [
					"system.user.read",
					"system.user.edit",
					"system.user.delete",
					"system.user.employee_bind",
					"system.employee.user_bind",
				],
				someIfsOn: null,
			},
			{
				id: "system.user.read",
				name: "Просмотр карточки пользователя",
				fields: null,
				someIfsOff: [
					"system.organization.edit",
					"system.organization.delete",
					"system.user.employee_bind",
					"system.employee.user_bind",
				],
				someIfsOn: ["system.user_dictionary.read"],
			},
			{
				id: "system.user.create",
				name: "Создание пользователей",
				fields: null,
				someIfsOff: null,
				someIfsOn: ["system.organization.read"],
			},
			{
				id: "system.user.edit",
				name: "Редактирование пользователя",
				fields: null,
				someIfsOff: null,
				someIfsOn: ["system.user_dictionary.read", "system.user.read"],
			},
			{
				id: "system.user.delete",
				name: "Удаление пользователей",
				fields: null,
				someIfsOff: null,
				someIfsOn: ["system.user_dictionary.read", "system.user.read"],
			},
			{
				id: "system.user.employee_bind",
				name: "Прикрепление к карточке пользователя карточки сотрудника",
				fields: null,
				someIfsOff: ["system.employee.user_bind"],
				someIfsOn: [
					"system.user_dictionary.read",
					"system.user.read",
					"system.employee.user_bind",
					"system.employee_dictionary.read",
					"system.employee.read",
				],
			},
			{
				id: "system.employee_dictionary.read",
				name: "Просмотр справочника сотрудников",
				fields: null,
				someIfsOff: [
					"system.employee.read",
					"system.employee.create",
					"system.user.delete",
					"system.user.employee_bind",
					"system.employee.user_bind",
				],
				someIfsOn: null,
			},
			{
				id: "system.employee.read",
				name: "Просмотр карточки сотрудника",
				fields: null,
				someIfsOff: ["system.employee.edit", "system.user.employee_bind", "system.employee.user_bind"],
				someIfsOn: ["system.employee_dictionary.read"],
			},
			{
				id: "system.employee.create",
				name: "Создание сотрудника",
				fields: null,
				someIfsOff: null,
				someIfsOn: ["system.employee_dictionary.read"],
			},
			{
				id: "system.employee.edit",
				name: "Редактирование сотрудника",
				fields: null,
				someIfsOff: null,
				someIfsOn: ["system.employee.read", "system.employee_dictionary.read"],
			},
			{
				id: "system.employee.user_bind",
				name: "Прикрепление к карточке сотрудника карточки пользователя",
				fields: null,
				someIfsOff: ["system.user.employee_bind"],
				someIfsOn: [
					"system.user_dictionary.read",
					"system.user.read",
					"system.user.employee_bind",
					"system.employee_dictionary.read",
					"system.employee.read",
				],
			},
		],
	},
	{
		id: "docs",
		name: "Документы",
		someIfsOff: [
			"document.organization_archive.read",
			"document.categorization_archive.read",
			"document.organization.read",
			"document.folder.create",
			"document.upload",
			"document.archival",
			"document.archive.restore",
			"document.version.read",
			"document.categorization.read",
		],
		someIfsOn: [
			"document.organization_archive.read",
			"document.categorization_archive.read",
			"document.organization.read",
			"document.folder.create",
			"document.upload",
			"document.archival",
			"document.archive.restore",
			"document.version.read",
			"document.categorization.read",
		],
		fields: [
			{
				id: "document.organization_archive.read",
				name: "Просмотр архива документов организации",
				fields: null,
				someIfsOff: null,
				someIfsOn: ["document.organization.read", "system.organization.read"],
			},
			{
				id: "document.categorization_archive.read",
				name: "Просмотр архива документов категорирования",
				fields: null,
				someIfsOff: null,
				someIfsOn: ["document.categorization.read", "system.organization.read", "document.organization.read"],
			},
			{
				id: "document.organization.read",
				name: "Просмотр документов организации",
				fields: null,
				someIfsOff: [
					"document.organization_archive.read",
					"document.folder.create",
					"document.upload",
					"document.archive.restore",
					"categorization.location_document.delete",
					"categorization.approved_categorization_document.upload",
					"categorization.categorization_document.read",
				],
				someIfsOn: ["system.organization.read", "document.categorization.read"],
			},
			{
				id: "document.categorization.read",
				name: "Просмотр документов категорирования",
				fields: null,
				someIfsOff: ["document.categorization_archive.read"],
				someIfsOn: ["system.organization.read", "document.organization.read"],
			},
			{
				id: "document.folder.create",
				name: "Создание папок",
				fields: null,
				someIfsOff: null,
				someIfsOn: ["document.organization.read", "system.organization.read"],
			},
			{
				id: "document.upload",
				name: "Загрузка документов",
				fields: null,
				someIfsOff: null,
				someIfsOn: ["document.organization.read", "system.organization.read"],
			},
			{
				id: "document.archival",
				name: "Архивирование папок и документов",
				fields: null,
				someIfsOff: null,
				someIfsOn: ["document.organization.read", "system.organization.read"],
			},
			{
				id: "document.archive.restore",
				name: "Восстановление документов и папок из архива",
				fields: null,
				someIfsOff: null,
				someIfsOn: [
					"system.organization.read",
					"document.organization.read",
					"document.organization_archive.read",
					"document.categorization_archive.read",
					"document.categorization.read",
				],
			},
			{
				id: "document.version.read",
				name: "Просмотр версионности",
				fields: null,
				someIfsOff: null,
				someIfsOn: null,
			},
		],
	},
	{
		id: "categoryzation",
		name: "Категорирование",
		someIfsOff: [
			// 'read',
			"step_one",
			"step_two",
			"step_three",
			"step_four",
			"step_five",
			"step_six",
			"step_seven",
			"steps",
		],
		someIfsOn: [
			// 'read',
			"step_one",
			"step_two",
			"step_three",
			"step_four",
			"step_five",
			"step_six",
			"step_seven",
			"system.organization.read",
		],
		fields: [
			// {
			// 	id: "read",
			// 	name: "",
			// 	someIfsOff: ["categorization.status.read"],
			// 	someIfsOn: ["categorization.status.read"],
			// 	fields: [
			// 		{
			// 			id: "categorization.status.read",
			// 			name: "Просмотр категорирования",
			// 			fields: null,
			// 			someIfsOff: null,
			// 			someIfsOn: null,
			// 		},
			// 	],
			// },
			{
				id: "steps",
				name: "",
				someIfsOff: ["step_one", "step_two", "step_three", "step_four", "step_five", "step_six", "step_seven"],
				someIfsOn: [
					"step_one",
					"step_two",
					"step_three",
					"step_four",
					"step_five",
					"step_six",
					"step_seven",
					"system.organization.read",
				],
				fields: [
					{
						id: "step_one",
						name: "Шаг 1",
						someIfsOff: [
							"categorization.commission.read",
							"categorization.commission.edit",
							"categorization.commission.delete",
						],
						someIfsOn: [
							"categorization.commission.read",
							"categorization.commission.edit",
							"categorization.commission.delete",
							"system.organization.read",
						],
						fields: [
							{
								id: "categorization.commission.read",
								name: "Просмотр",
								fields: null,
								someIfsOff: ["categorization.commission.edit", "categorization.commission.delete"],
								someIfsOn: ["categorization.status.read", "system.organization.read"],
							},
							{
								id: "categorization.commission.edit",
								name: "Создание/редактирование состава комиссии",
								fields: null,
								someIfsOff: null,
								someIfsOn: ["categorization.commission.read", "system.organization.read"],
							},
							{
								id: "categorization.commission.delete",
								name: "Удаление комиссии",
								fields: null,
								someIfsOff: null,
								someIfsOn: ["categorization.commission.read", "system.organization.read"],
							},
						],
					},
					{
						id: "step_two",
						someIfsOff: [
							"categorization.business_process_registry.read",
							"categorization.business_process_registry.print",
							"categorization.business_process_registry.edit",
							"categorization.approved_business_process_registry.upload",
							"categorization.object_registry.read",
							"categorization.object_registry.print",
							"categorization.object_registry.edit",
							"categorization.approved_object_registry.upload",
						],
						someIfsOn: [
							"categorization.business_process_registry.read",
							"categorization.business_process_registry.print",
							"categorization.business_process_registry.edit",
							"categorization.approved_business_process_registry.upload",
							"categorization.object_registry.read",
							"categorization.object_registry.print",
							"categorization.object_registry.edit",
							"categorization.approved_object_registry.upload",
							"system.organization.read",
						],
						name: "Шаг 2",
						fields: [
							{
								id: "categorization.business_process_registry.read",
								name: "Просмотр реестр БП",
								fields: null,
								someIfsOff: [
									"categorization.business_process_registry.print",
									"categorization.business_process_registry.edit",
									"categorization.approved_business_process_registry.upload",
								],
								someIfsOn: ["categorization.status.read", "system.organization.read"],
							},
							{
								id: "categorization.business_process_registry.print",
								name: "Печать реестра БП",
								fields: null,
								someIfsOff: null,
								someIfsOn: [
									"categorization.business_process_registry.read",
									"categorization.status.read",
									"system.organization.read",
								],
							},
							{
								id: "categorization.business_process_registry.edit",
								name: "Редактирование реестр БП",
								fields: null,
								someIfsOff: null,
								someIfsOn: [
									"categorization.business_process_registry.read",
									"categorization.status.read",
									"system.organization.read",
								],
							},
							{
								id: "categorization.approved_business_process_registry.upload",
								name: "Загрузка утвержденной версии реестра БП",
								fields: null,
								someIfsOff: null,
								someIfsOn: [
									"categorization.business_process_registry.read",
									"categorization.status.read",
									"system.organization.read",
								],
							},
							{
								id: "categorization.object_registry.read",
								name: "Просмотр реестр объектов",
								fields: null,
								someIfsOff: [
									"categorization.object_registry.print",
									"categorization.object_registry.edit",
									"categorization.approved_object_registry.upload",
									"categorization.object_list.edit",
								],
								someIfsOn: ["categorization.status.read", "system.organization.read"],
							},
							{
								id: "categorization.object_registry.print",
								name: "Печать реестра объектов",
								fields: null,
								someIfsOff: null,
								someIfsOn: [
									"categorization.object_registry.read",
									"categorization.status.read",
									"system.organization.read",
								],
							},
							{
								id: "categorization.object_registry.edit",
								name: "Редактирование реестра объектов",
								fields: null,
								someIfsOff: null,
								someIfsOn: [
									"categorization.object_registry.read",
									"categorization.status.read",
									"system.organization.read",
								],
							},
							{
								id: "categorization.approved_object_registry.upload",
								name: "Загрузка утвержденной версии реестра объектов",
								fields: null,
								someIfsOff: null,
								someIfsOn: [
									"categorization.object_registry.read",
									"categorization.status.read",
									"system.organization.read",
								],
							},
						],
					},
					{
						id: "step_three",
						someIfsOff: [
							"categorization.object_list.read",
							"categorization.object_list.edit",
							"categorization.object_list.print",
							"categorization.approved_object_list.upload",
						],
						someIfsOn: [
							"categorization.object_list.read",
							"categorization.object_list.edit",
							"categorization.object_list.print",
							"categorization.approved_object_list.upload",
							"system.organization.read",
						],
						name: "Шаг 3",
						fields: [
							{
								id: "categorization.object_list.read",
								name: "Просмотр перечня/дополнения в перечень",
								fields: null,
								someIfsOff: [
									"categorization.object_list.edit",
									"categorization.object_list.print",
									"categorization.approved_object_list.upload",
								],
								someIfsOn: ["categorization.status.read", "system.organization.read"],
							},
							{
								id: "categorization.object_list.edit",
								name: "Создание/редактирование перечня",
								fields: null,
								someIfsOff: null,
								someIfsOn: [
									"categorization.object_list.read",
									"categorization.object_registry.read",
									"categorization.status.read",
									"system.organization.read",
								],
							},
							{
								id: "categorization.object_list.print",
								name: "Печать перечня",
								fields: null,
								someIfsOff: null,
								someIfsOn: [
									"categorization.object_list.read",
									"categorization.status.read",
									"system.organization.read",
								],
							},
							{
								id: "categorization.approved_object_list.upload",
								name: "Загрузка утвержденной версии",
								fields: null,
								someIfsOff: null,
								someIfsOn: [
									"categorization.object_list.read",
									"categorization.status.read",
									"system.organization.read",
								],
							},
						],
					},
					{
						id: "step_four",
						someIfsOff: [
							"categorization.threat_model.read",
							"categorization.threat_model.edit",
							"categorization.approved_threat_model.upload",
							"categorization.damage.read",
							"categorization.damage.edit",
						],
						someIfsOn: [
							"categorization.threat_model.read",
							"categorization.threat_model.edit",
							"categorization.approved_threat_model.upload",
							"system.organization.read",
							"categorization.damage.read",
							"categorization.damage.edit",
						],
						name: "Шаг 4",
						fields: [
							{
								id: "categorization.threat_model.read",
								name: "Просмотр МУ",
								fields: null,
								someIfsOff: ["categorization.threat_model.edit", "categorization.approved_threat_model.upload"],
								someIfsOn: ["categorization.status.read", "system.organization.read"],
							},
							{
								id: "categorization.threat_model.edit",
								name: "Редактирование данных МУ",
								fields: null,
								someIfsOff: null,
								someIfsOn: [
									"categorization.threat_model.read",
									"categorization.status.read",
									"system.organization.read",
								],
							},
							{
								id: "categorization.approved_threat_model.upload",
								name: "Загрузка утвержденной версии МУ",
								fields: null,
								someIfsOff: null,
								someIfsOn: [
									"categorization.threat_model.read",
									"categorization.status.read",
									"system.organization.read",
								],
							},
							{
								id: "categorization.damage.read",
								name: "Просмотр расчета экономического ущерба",
								fields: null,
								someIfsOff: ["categorization.damage.edit"],
								someIfsOn: null,
							},
							{
								id: "categorization.damage.edit",
								name: "Заполнение/редактирование данных РЭУ",
								fields: null,
								someIfsOff: null,
								someIfsOn: ["categorization.damage.read"],
							},
						],
					},
					{
						id: "step_five",
						someIfsOff: [
							"categorization.step_5.read",
							"categorization.category.assign",
							"categorization.location_document.delete",
							"categorization.approved_categorization_document.upload",
							"categorization.categorization_document.read",
						],
						someIfsOn: [
							"categorization.step_5.read",
							"categorization.category.assign",
							"categorization.location_document.delete",
							"categorization.approved_categorization_document.upload",
							"categorization.categorization_document.read",
							"system.organization.read",
						],
						name: "Шаг 5",
						fields: [
							{
								id: "categorization.step_5.read",
								name: "Просмотр данных",
								fields: null,
								someIfsOff: [
									"categorization.category.assign",
									"categorization.location_document.delete",
									"categorization.approved_categorization_document.upload",
									"categorization.categorization_document.read",
								],
								someIfsOn: ["system.organization.read"],
							},
							{
								id: "categorization.category.assign",
								name: "Присвоение категории",
								fields: null,
								someIfsOff: null,
								someIfsOn: ["categorization.step_5.read", "categorization.status.read", "system.organization.read"],
							},
							{
								id: "categorization.location_document.delete",
								name: "Возможность удаления документов по адресам",
								fields: null,
								someIfsOff: null,
								someIfsOn: [
									"categorization.step_5.read",
									// "document.organization.read",
									"categorization.status.read",
									"system.organization.read",
								],
							},
							{
								id: "categorization.approved_categorization_document.upload",
								name: "Загрузка утвержденных документов",
								fields: null,
								someIfsOff: null,
								someIfsOn: [
									"categorization.step_5.read",
									// "document.organization.read",
									"categorization.status.read",
									"system.organization.read",
								],
							},
							{
								id: "categorization.categorization_document.read",
								name: "Просмотр формируемых документов",
								fields: null,
								someIfsOff: null,
								someIfsOn: [
									"categorization.step_5.read",
									// "document.organization.read",
									"categorization.status.read",
									"system.organization.read",
								],
							},
						],
					},
					{
						id: "step_six",
						someIfsOff: [
							"categorization.step_6.read",
							"categorization.fstek_export_bundle.create",
							"categorization.fstek_export_bundle.read",
						],
						someIfsOn: [
							"categorization.step_6.read",
							"categorization.fstek_export_bundle.create",
							"categorization.fstek_export_bundle.read",
							"system.organization.read",
						],
						name: "Шаг 6",
						fields: [
							{
								id: "categorization.step_6.read",
								name: "Просмотр данных",
								fields: null,
								someIfsOff: ["categorization.fstek_export_bundle.create", "categorization.fstek_export_bundle.read"],
								someIfsOn: ["categorization.status.read", "system.organization.read"],
							},
							{
								id: "categorization.fstek_export_bundle.create",
								name: "Формирование архива",
								fields: null,
								someIfsOff: null,
								someIfsOn: ["categorization.step_6.read", "categorization.status.read", "system.organization.read"],
							},
							{
								id: "categorization.fstek_export_bundle.read",
								name: "Просмотр партий документов",
								fields: null,
								someIfsOff: null,
								someIfsOn: ["categorization.step_6.read", "categorization.status.read", "system.organization.read"],
							},
						],
					},
					{
						id: "step_seven",
						someIfsOff: ["categorization.step_7.read", "categorization.step_7.edit"],
						someIfsOn: ["categorization.step_7.read", "categorization.step_7.edit", "system.organization.read"],
						name: "Шаг 7",
						fields: [
							{
								id: "categorization.step_7.read",
								name: "Просмотр данных",
								fields: null,
								someIfsOff: ["categorization.step_7.edit"],
								someIfsOn: ["categorization.status.read", "system.organization.read"],
							},
							{
								id: "categorization.step_7.edit",
								name: "Добавление данных",
								fields: null,
								someIfsOff: null,
								someIfsOn: [
									"categorization.step_7.read",
									"step_seven",
									"categorization.status.read",
									"system.organization.read",
								],
							},
						],
					},
				],
			},
		],
	},
];
